import { render, staticRenderFns } from "./tooltip_Info2.vue?vue&type=template&id=91671592"
import script from "./tooltip_Info2.vue?vue&type=script&lang=js"
export * from "./tooltip_Info2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports